import React from 'react';
import './ToggleSwitch.scss';

type AppProps = {
  isChecked: boolean | undefined;
  handleToggleChange: (name?:string|undefined) => void;
  disabled?:boolean;
  name?:string
}

const ToggleSwitch = ({ isChecked, handleToggleChange,disabled,name }: AppProps) => {
  
  return (
    <div>
      <label className="switch">
        <input
          type="checkbox"
          checked={isChecked}
          onChange={()=>{name?.length?handleToggleChange(name):handleToggleChange()
            
          }}
          disabled={disabled}
        />
        <span className="slider round" style={{backgroundColor:disabled&&disabled?"gray":""}}></span>
      </label>
    </div>
  )
};

export default ToggleSwitch;